import { useRef, useState } from "react";

import Actionbar from "src/components/common/actionbar/Authactionbar";
import LoadingOverlay from "src/components/common/form/LoadingOverlay";
import { Message } from "src/components/common/form/Message";
import useUiuxStore from "src/store/useUiuxStore";

import { Content_SAL2040_R01 } from "./Content_SAL2040_R01";
import { SearchSection_SAL2040_R01 } from "./SearchSection_SAL2040_R01";
import { useSAL2040_R01Store } from "./Store_SAL2040_R01";
import { Table_SAL2040_R01 } from "./Table_SAL2040_R01";
import { AgGridReact } from "ag-grid-react";
import { SAL2040_R01Dto } from "./Dto_SAL2040_R01";


export const Container_SAL2040_R01 = () => {

	const { 
		allCount,
		initData, 
	} = useSAL2040_R01Store();

	const { setMessage } = useUiuxStore();

	const gridRef = useRef<AgGridReact<SAL2040_R01Dto>>(null);

	const {
		fetchData,
		handleExcelClick,
	} = Content_SAL2040_R01({
		gridRef,
		setMessage,
	});

	return <div className={`content-container`}>
		
		<Actionbar
			onFetchClick={fetchData}
			onCreateClick={undefined}
			onDeleteClick={undefined}
			onSaveClick={undefined}
			onPrintClick={undefined}
			onExcelClick={handleExcelClick}
			onInitClick={() => { initData(); } }
		/>
		<SearchSection_SAL2040_R01 />

		<div className="flex flex-col flex-1 p-[12px] gap-[4px] min-h-0">
			<div className="w-full flex-1">
				<Table_SAL2040_R01 gridRef={gridRef} />
			</div>
		</div>
		<Message />
	</div>
}

